import React, { Component } from "react";
import "./index.css";

// Import logos
import patronatHonorowyPL from "../../../assets/images/patronat_honorowy_prezydent_PL.png";
import patronatHonorowyEN from "../../../assets/images/patronat_honorowy_prezydent_EN.png";
import nifcLogo from "../../../assets/images/Logo-color.svg";
import mkidnLogo from "../../../assets/images/mkidn.webp";
import totalizatorLogo from "../../../assets/images/totalizator.svg";
import pzuLogo from "../../../assets/images/pzu.svg";
import pzuNewLogo from "../../../assets/images/pzu-vwMSPsMzdCUwi3C7vVPi0ygtgetz9q.webp";
import lottoLogo from "../../../assets/images/lotto-zZGKj7RNxq64pAl8vycHl8OWiv3j4y.webp";
import warszawaLogo from "../../../assets/images/okecie-pl.jpg";
import tvpLogo from "../../../assets/images/TVP.png";
import lexusLogo from "../../../assets/images/Lexus.png";
import lotniskoLogo from "../../../assets/images/okecie-pl.jpg";
import emitelLogo from "../../../assets/images/nowe_logo_firmy_emitel.png";
import yamahaLogo from "../../../assets/images/Yamaha-Logo-gjSr5652HfV7rWqYokcVJXGTapBAyp.webp";
import robertDobrzyckiLogo from "../../../assets/images/533131e3-85da-4c08-bd37-972bcf0bdddc-KjB6onytcCYKP8sxBtP5SxOAzM7cr6.webp";
import regentLogo from "../../../assets/images/regent.svg";
import cloudwareLogo from "../../../assets/images/cloudware-logo.webp";
import ebiletLogo from "../../../assets/images/eBilet-icon.webp";
import filharmoniaLogo from "../../../assets/images/filharmonia-narodowa-warszawa1-530x140-BOTGSvg6M0Vlo9GMpp8zbLCQPwxsl4.webp";
import iamLogo from "../../../assets/images/IAM.svg";
import orskaLogo from "../../../assets/images/orska.webp";
import miraculumLogo from "../../../assets/images/miraculum_1924.webp";
import newLogo1 from "../../../assets/images/115b633c-bd6f-4c55-9c4d-63594d3dc4f3-GXnbP2SxdcQLtQddjIv5tXxsfHgeXe.webp";
import newLogo2 from "../../../assets/images/d1860261-0230-4f42-98db-053577250511-b4FUsIwNTu793EtUQ0XGiBPhs3nO2f.webp";
import newLogo3 from "../../../assets/images/aea91d48-6b1e-4be5-b336-f8ee79f8a237-Hux6WMDzK7bILpqGPQJiZqnSxhl7oj.webp";
import lotLogo from "../../../assets/images/lot-8arDWebKne1BeJFpJDTAyuDgodD3kJ.webp";
import tvpKulturaLogo from "../../../assets/images/images-6-zpHwG1NffPmuU1ry9iBpXMs2bIeJEP.webp";
import polskieRadioLogo from "../../../assets/images/polskie_radio_100_lat.svg";
import chopinRadioLogo from "../../../assets/images/591ad449-3daa-4e79-a4c8-1e4465e918a0-ojIzhbCI6tHiBX6KtHljTgzTxo25JY.webp";
import papLogo from "../../../assets/images/PAP.svg";
import elleLogo from "../../../assets/images/ELLE.svg";
import rzeczpospolitaLogo from "../../../assets/images/Rzeczpospolita.svg";
import gramophoneLogo from "../../../assets/images/gramophone_logo.webp";
import orlenLogo from "../../../assets/images/orlen-square-r2Za55EsiveoD3Geu2LXyPCAN93v0p.webp";
import pkoLogo from "../../../assets/images/pko_logo.webp";

export default class PartnersContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: this.getLanguage()
        };
    }

    getLanguage() {
        if (typeof window !== 'undefined') {
            return window.location.pathname.indexOf('/en/') === 0 ? 'en' : 'pl';
        }
        return 'pl';
    }

    render() {
        const { lang } = this.state;
        const isEN = lang === 'en';
        

        return (
            <div className="partners-content">
                <div className="partners-header">
                    <h1 className="partners-title">{isEN ? "PARTNERS" : "PARTNERZY"}</h1>
                    <p className="partners-description">
                        {isEN 
                            ? "We thank the institutions and organizations supporting the International Fryderyk Chopin Piano Competition."
                            : "Dziękujemy instytucjom i organizacjom wspierającym Międzynarodowy Konkurs Pianistyczny im. Fryderyka Chopina."
                        }
                    </p>
                </div>

                <div className="partners-sections">
                    {/* ORGANIZATORZY */}
                    <div className="partners-section">
                        <div className="section-header">
                            <h2>{isEN ? "ORGANIZERS" : "ORGANIZATORZY"}</h2>
                        </div>
                            <div className="section-content">
                                <div className="partner-item">
                                    <a href="https://www.prezydent.pl/" target="_blank" rel="noopener noreferrer">
                                        <img src={isEN ? patronatHonorowyEN : patronatHonorowyPL} alt="Patronat Honorowy Prezydenta RP" />
                                    </a>
                                </div>
                            </div>
                    </div>

                    {/* PREZYDENT RP */}
                    <div className="partners-section">
                        <div className="section-header">
                            <h2>{isEN ? "PRESIDENT OF THE REPUBLIC OF POLAND" : "PREZYDENT RP"}</h2>
                        </div>
                            <div className="section-content">
                                <div className="partner-item">
                                    <a href="https://nifc.pl/pl" target="_blank" rel="noopener noreferrer">
                                        <img src={nifcLogo} alt="Narodowy Instytut Fryderyka Chopina" />
                                    </a>
                                </div>
                            </div>
                    </div>

                    {/* GŁÓWNY ORGANIZATOR */}
                    <div className="partners-section glowny-organizator">
                        <div className="section-header">
                            <h2>{isEN ? "MAIN ORGANIZER" : "GŁÓWNY ORGANIZATOR"}</h2>
                        </div>
                    </div>

                    {/* DOFINANSOWANO */}
                    <div className="partners-section dofinansowano">
                        <div className="section-content">
                            <div className="partner-item large-logo">
                                <a href="https://www.gov.pl/web/kultura" target="_blank" rel="noopener noreferrer">
                                    <img src={mkidnLogo} alt="Ministerstwo Kultury i Dziedzictwa Narodowego" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "FUNDED BY THE MINISTRY OF CULTURE AND NATIONAL HERITAGE" : "DOFINANSOWANO ZE ŚRODKÓW MINISTRA KULTURY I DZIEDZICTWA NARODOWEGO"}</h2>
                        </div>
                    </div>

                    {/* MECENAS */}
                    <div className="partners-section mecenas">
                        <div className="section-content">
                            <div className="partner-item">
                                <a href="https://www.orlen.pl/pl" target="_blank" rel="noopener noreferrer">
                                    <img src={orlenLogo} alt="PKN Orlen" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "PATRON" : "MECENAS"}</h2>
                        </div>
                    </div>

                    {/* PARTNER STRATEGICZNY */}
                    <div className="partners-section">
                        <div className="section-content">
                            <div className="partner-item">
                                <a href="https://www.pkobp.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={pkoLogo} alt="PKO Bank Polski" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "STRATEGIC PARTNER" : "PARTNER STRATEGICZNY"}</h2>
                        </div>
                    </div>

                    {/* PARTNER GŁÓWNY */}
                    <div className="partners-section partner-glowny">
                        <div className="section-content">
                            <div className="partner-item">
                                <a href="https://www.totalizator.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={lottoLogo} alt="Lotto" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "MAIN PARTNER" : "PARTNER GŁÓWNY"}</h2>
                        </div>
                    </div>

                    {/* PARTNER ZŁOTY - PZU */}
                    <div className="partners-section">
                        <div className="section-content">
                            <div className="partner-item">
                                <a href="https://www.pzu.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={pzuNewLogo} alt="PZU" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "GOLDEN PARTNER" : "PARTNER ZŁOTY"}</h2>
                        </div>
                    </div>

                    {/* PARTNER ZŁOTY */}
                    <div className="partners-section partner-zloty">
                        <div className="section-content partners-grid">
                            <div className="partner-item">
                                <a href="https://um.warszawa.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={newLogo1} alt="Partner 1" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://tvp.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={tvpLogo} alt="TVP" />
                                </a>
                            </div>
                            <div className="partner-item small-logo">
                                <a href="https://www.polskieradio.pl/8,dwojka" target="_blank" rel="noopener noreferrer">
                                    <img src={newLogo2} alt="Partner 2" />
                                </a>
                            </div>
                            <div className="partner-item small-logo">
                                <a href="https://chopin.edu.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={newLogo3} alt="Partner 3" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "CO-ORGANIZERS" : "WSPÓŁORGANIZATORZY"}</h2>
                        </div>
                    </div>

                    {/* WSPÓŁORGANIZATORZY */}
                    <div className="partners-section wspolorganizatorzy">
                        <div className="section-content partners-grid">
                            <div className="partner-item">
                                <a href="https://www.lexus-polska.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={lexusLogo} alt="LEXUS" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://www.lotnisko-chopina.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={lotniskoLogo} alt="LOTNISKO CHOPINA WARSZAWA" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://emitel.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={emitelLogo} alt="emitel" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://pl.yamaha.com/index.html" target="_blank" rel="noopener noreferrer">
                                    <img src={yamahaLogo} alt="YAMAHA" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://rdfoundation.org/" target="_blank" rel="noopener noreferrer">
                                    <img src={robertDobrzyckiLogo} alt="ROBERT DOBRZYCKI foundation" />
                                </a>
                            </div>
                            <div className="partner-item large-logo">
                                <a href="https://www.regent-warsaw.com/" target="_blank" rel="noopener noreferrer">
                                    <img src={regentLogo} alt="REGENT" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://cloudware.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={cloudwareLogo} alt="cloudware" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://www.ebilet.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={ebiletLogo} alt="eBilet" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://filharmonia.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={filharmoniaLogo} alt="FILHARMONIA NARODOWA" />
                                </a>
                            </div>
                            <div className="partner-item large-logo">
                                <a href="https://iam.pl/pl" target="_blank" rel="noopener noreferrer">
                                    <img src={iamLogo} alt="INSTYTUT ADAMA MICKIEWICZA" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href={isEN ? "https://orskastore.com/?_gl=1*1iwflq4*_gcl_aw*R0NMLjE3NTgxMjgyMTQuRUFJYUlRb2JDaE1JdnQzOTRxSGdqd01WMEtqOUJSM2hDUTl3RUFBWUFTQUFFZ0pEZ3ZEX0J3RQ..*_gcl_au*MTgxMzY5OTE2LjE3NTgxMjgyMDU." : "https://orska.pl/"} target="_blank" rel="noopener noreferrer">
                                    <img src={orskaLogo} alt="ORSKA" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://miraculum.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={miraculumLogo} alt="MIRACULUM 1924" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "PARTNERS" : "PARTNERZY"}</h2>
                        </div>
                    </div>

                    {/* PARTNERZY */}
                    <div className="partners-section">
                        <div className="section-content">
                            <div className="partner-item small-logo">
                                <a href="https://www.lot.com/pl/pl" target="_blank" rel="noopener noreferrer">
                                    <img src={lotLogo} alt="LOT Polish Airlines" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "OFFICIAL NIFC CARRIER" : "OFICJALNI PRZEWOŹNIK NIFC"}</h2>
                        </div>
                    </div>

                    {/* PARTNERZY MEDIALNI */}
                    <div className="partners-section">
                        <div className="section-content partners-grid">
                            <div className="partner-item small-logo">
                                <a href="https://tvpkultura.tvp.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={tvpKulturaLogo} alt="TVP KULTURA" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://podcasty.polskieradio.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={polskieRadioLogo} alt="100 LAT POLSKIEGO RADIA" />
                                </a>
                            </div>
                            <div className="partner-item small-logo">
                                <a href="https://chopin.polskieradio.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={chopinRadioLogo} alt="Polskie Radio Chopin" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://www.pap.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={papLogo} alt="PAP Polska Agencja Prasowa" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://www.elle.pl/kultura/" target="_blank" rel="noopener noreferrer">
                                    <img src={elleLogo} alt="ELLE" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://www.rp.pl/" target="_blank" rel="noopener noreferrer">
                                    <img src={rzeczpospolitaLogo} alt="RZECZPOSPOLITA" />
                                </a>
                            </div>
                            <div className="partner-item">
                                <a href="https://www.gramophone.co.uk/" target="_blank" rel="noopener noreferrer">
                                    <img src={gramophoneLogo} alt="GRAMOPHONE" />
                                </a>
                            </div>
                        </div>
                        <div className="section-header">
                            <h2>{isEN ? "MEDIA PARTNERS" : "PARTNERZY MEDIALNI"}</h2>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/PartnersContent/index.js